import { FormDataStateMap } from 'state/formData';
import * as XLSX from 'xlsx';

export function createBatchWorkbook(
  fieldValues: FormDataStateMap,
  sheetName: string = 'SG Markets Structured Products',
): XLSX.WorkBook {
  const headers = getKeysOfMostPopulatedRow(fieldValues);
  const dataRows = [];
  for (const rowData in fieldValues) {
    const formData = fieldValues[rowData];
    const row = [];
    for (const header of headers) {
      row.push(header in formData ? formData[header] : '');
    }
    dataRows.push(row);
  }
  const worksheetData = [headers, ...dataRows];
  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  return workbook;
}

// Finds the form entry with the most fields and returns its keys
const getKeysOfMostPopulatedRow = (formDataStateMap: FormDataStateMap): string[] => {
  let maxKeyCount = 0;
  let formWithMostKeys: Record<string, any> | undefined;
  const keys: string[] = [];

  for (const key in formDataStateMap) {
    const form = formDataStateMap[key];
    const keyCount = Object.keys(form).length;

    if (keyCount > maxKeyCount) {
      maxKeyCount = keyCount;
      formWithMostKeys = form;
    }
  }
  if (formWithMostKeys) {
    for (const k in formWithMostKeys) {
      keys.push(k);
    }
  }
  return keys;
};
